import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import messengerSocket from '../../utils/messengerSocket';
import {
  loadUnreadSummary,
  upsertInboxItem,
  upsertTeamInboxItem,
} from '../../Redux/ActionCreators/chatAction';

const UNREAD_REFRESH_DEBOUNCE_MS = 300;

// Keeps the shared messenger socket open while mainLayout is mounted and keeps
// the inbox / unread badge in sync from socket events.
const useMessengerSocket = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let unreadTimer = null;
    const refreshUnread = () => {
      clearTimeout(unreadTimer);
      unreadTimer = setTimeout(() => dispatch(loadUnreadSummary()), UNREAD_REFRESH_DEBOUNCE_MS);
    };

    dispatch(loadUnreadSummary());

    const offOpen = messengerSocket.addListener('open', ({ reconnected }) => {
      // Catch up on anything missed while disconnected
      if (reconnected) refreshUnread();
    });

    const offMessage = messengerSocket.addListener('message', (data) => {
      if (data.type === 'conversation_inbox_updated' && data.item) {
        dispatch(upsertInboxItem(data.item));
        refreshUnread();
        return;
      }
      if (data.type === 'internal_inbox_updated' && data.item) {
        dispatch(upsertTeamInboxItem(data.item));
        refreshUnread();
      }
    });

    const handleLogout = () => messengerSocket.disconnect();
    window.addEventListener('APP_LOGOUT', handleLogout);

    messengerSocket.connect();

    return () => {
      clearTimeout(unreadTimer);
      offOpen();
      offMessage();
      window.removeEventListener('APP_LOGOUT', handleLogout);
      messengerSocket.disconnect();
    };
  }, [dispatch]);
};

export default useMessengerSocket;
